<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="MONTH END SALES REPORT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="from" name="from" rules="required" v-slot="{ errors }">
                <small class="label">Month and Year</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="flatPkrConfig"
                            v-model="from_date"
                            placeholder=""
                />
                <flat-pickr
                            class="w-full"
                            :config="flatPkrConfig"
                            v-model="from_date"
                            placeholder=""
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3 hidden">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="currencies" name="currencies" rules="" v-slot="{ errors }">
                <small class="label">Account Currency</small>
              <v-select :clearable="true" v-model="selectedCurrency"
                        :options="currencies"
                        multiple
                        label="name"
                        :reduce="option => option.value"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="account_type" name="account_type" rules="" v-slot="{ errors }">
                <small class="label">Customer Account Type</small>
              <v-select :clearable="true" v-model="selected_account_type"
                        :options="['Proforma', 'Credit']"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Send Email</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import 'flatpickr/dist/plugins/monthSelect/style.css'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import Utils from "@/mixins/Utils";
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'

export default {
  name: "DownloadMonthEndSalesReportPopUp",
  data () {
    return {
      open: false,
      endPoint: '',
      date:'',
      to_date: '',
      from_date: '',
      selectedCurrency: [],
      selected_account_type: ''
    }
  },
  mixins:[Utils, SuccessMessage],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods:{
    openPopup(end_point, range, filters) {
      this.open = true
      if(!!range) {
        let arr = range.split(' to ')
        this.from_date = arr[0]
        this.to_date = arr[1]
      }
      this.selectedCurrency = filters.account_currency ? filters.account_currency : []
      this.selected_account_type = filters.account_type || ""
      this.endPoint = end_point
      this.currencies = this.getDropdownData('account_currency')
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadReportDocument(this.endPoint, `month_year=${this.from_date}`)
        // let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        // let fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', `All Sales Margin Report (${this.from_date} - ${this.to_date}).xlsx`);
        // document.body.appendChild(fileLink);
        // fileLink.click();
        this.showSuccessMessage('Report sent successfully')
        this.open = false
      } catch (e) {

      }
      this.$vs.loading.close()
    }
  },
  computed: {
    flatPkrConfig: function () {
      return {
        dateFormat: 'm/Y',
        plugins: [
          new MonthSelectPlugin({
            shorthand: true,
            dateFormat: "m/Y",
          })
        ],
      }
    }
  }
}
</script>

<style scoped>

</style>
